import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationMessagesComponent } from './components/validationMessages.component';

import { BusinessServices } from './../businesses/services/business.services';
import { ValidationService } from './services/validation.service';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslatePipe, TranslateDirective],
  declarations: [ValidationMessagesComponent],
  exports: [ValidationMessagesComponent],
  providers: [BusinessServices, ValidationService]
})
export class WidgetsModule {}
